<template>
    <div class="wrap" v-on-click-outside="closePopup">
        <div class="wrap-header" @click="checkOpen()">
            <div class="wrap-header-selected">
                <span class="wrap-header-selected--placeholder" v-if="selected === ''">
                    {{ setPlaceholder() }}
                    {{ placeholder }}
                </span>
                <span class="wrap-header-selected--active" v-else>
                    {{ selected }}
                </span>
            </div>
            <div :class="{
                'wrap-header-arrow': open === false,
                'wrap-header-arrow wrap-header-arrow--active': open === true
            }">
                <SvgIcon class="wrap-header-arrow-icon" iconName="ico-chevron-down" />
            </div>
        </div>
        <div class="wrap-content" v-if="open">
            <ul v-if="item.length">
                <li v-for="term in item" :key="term.term_id" @click="setAttr(term, filterTerms)" :value="term.term_id"
                    :class="selectedFilter(term, filterTerms)">
                    {{ term.name }}
                </li>
            </ul>
        </div>
        <div class="wrap-header-close" @click="removeAttr()" v-if="selected"></div>
    </div>
</template>

<script>
import { mixin as onClickOutside } from 'vue-on-click-outside';
import { mapState } from 'vuex';
import SvgIcon from '../../../base/SvgIcon/SvgIcon.vue';

export default {
    props: ['item', 'filterTerms', 'image'],
    mixins: [onClickOutside],
    data() {
        return {
            open: false,
            selected: '',
            term: {},
            placeholder: '',
            empty: false
        };
    },
    components: {
        SvgIcon
    },
    watch: {
        selectedAttributes() {
            if (Object.keys(this.selectedAttributes).length === 0) {
                return (this.selected = '');
            }
            this.checkSelected();
        }
    },
    mounted() {
        this.checkSelected();
    },
    computed: {
        ...mapState({
            selectedAttributes: state => state.Pagination.selectedAttributes,
            fetchInProgress: state => state.Pagination.fetchInProgress
        })
    },
    methods: {
        checkOpen() {
            if (this.fetchInProgress) return;
            let count = 0;
            this.item.forEach(term => {
                if (this.filterTerms[term.term_id]) {
                    count++;
                }
            });

            if (count > 0) {
                this.open = !this.open;
            }
        },

        checkSelected() {
            if (Object.keys(this.selectedAttributes).length > 0) {
                const foundTerm = this.item.find(
                    x => this.selectedAttributes[x.taxonomy] === x.term_id
                );
                if (foundTerm) {
                    this.setSelectedTerm(foundTerm);
                }
            }
        },

        selectedFilter(term, filterTerms) {
            let cssClass = '';

            filterTerms[term.term_id]
                ? (cssClass += 'selectable--yes')
                : (cssClass += 'selectable--no');
            if (this.selected === term.name) {
                cssClass += ' selected';
            }
            return cssClass;
        },

        setPlaceholder() {
            let tax = this.item[0]?.taxonomy;
            tax = tax.substring(3);
            tax = tax.charAt(0).toUpperCase() + tax.slice(1);
            this.placeholder = tax;
        },

        selectedSet() {
            if (this.selected === '') {
                const key = this.item[0]?.taxonomy;
                const str = key.split('_');
                const nameCapitalized =
                    str[1].charAt(0).toUpperCase() + str[1].slice(1);
                this.selected = nameCapitalized;
            }
        },

        // TODO: check if filterTerms is needed
        setAttr(term, filterTerms) {
            // if (!filterTerms[term.term_id]) {
            //     return false;
            // }
            filterTerms ? null : null;
            this.open = false;
            this.setSelectedTerm(term);
            this.$emit('setAttrOnClick', term);
        },

        removeAttr() {
            this.selected = '';
            this.$emit('removeAttr', this.term);
        },

        closePopup() {
            this.open = false;
        },
        setSelectedTerm(term) {
            this.term = term;
            this.selected = term.name;
        }
    }
};
</script>

<style lang="scss" scoped>
.wrap {
    position: relative;
}

.wrap-header {
    position: relative;
    width: 100%;
    height: 67px;
    border-radius: 6px;
    background-color: $white;
    border: 1px solid $theme-green;

    @include mq($lg) {
        width: 100%;
    }

    @include mq($md) {
        height: 50px;
    }
}

.wrap-header.disabled {
    border: 1px solid $gray;
}

.wrap-header-selected {
    height: 100%;
    display: flex;
    align-items: center;
    padding: 10px 60px 10px 15px;
    font-weight: 500;
    font-family: $font-main;
    letter-spacing: 0.8px;
}

.wrap-header-selected--active {
    color: $black;
    font-size: 16px;
    @include text-overflow;
}

.wrap-header-selected--placeholder {
    font-size: 14px;
    color: $gray;
}

.wrap-header-arrow {
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
    height: 22px;
}

.wrap-header-arrow--active {
    .wrap-header-arrow-icon {
        transition: $dur $ease;
        transform: rotateX(-180deg);
    }
}

.wrap-header-arrow-icon {
    font-size: 22px;
    height: 22px;
    width: 22px;
    transition: $dur $ease;
}

.wrap-header-close {
    position: absolute;
    top: 50%;
    right: 40px;
    transform: translateY(-50%);
    height: 22px;
    width: 22px;
    font-size: 22px;
    cursor: pointer;

    &::before,
    &::after {
        content: '';
        background-color: $black;
        height: 1px;
        width: 12px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: $dur $ease;
    }

    &::before {
        transform: translate(-50%, -50%) rotate(-45deg);
    }

    &::after {
        transform: translate(-50%, -50%) rotate(45deg);
    }
}

.wrap-content {
    width: 99%;
    background: white;
    padding: 5px 0;
    position: absolute;
    left: 0.5%;
    top: 67px;
    z-index: 2;
    box-shadow: 0 3px 5px 0 rgba($black, 0.55);
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;

    @include mq($md) {
        top: 51px;
    }

    ul {
        max-height: 200px;
        overflow: auto;
        @include scroll-style(rgba($green, 0.5), rgba($theme-green, 0.2), 30px, 0.3vw);

        li {
            cursor: pointer;
            padding: 15px 10px;
            transition: $dur $ease;
            color: $black;

            &:hover {
                transition: $dur $ease;
                background-color: $theme-green-light;
            }
        }
    }

    .selected {
        background-color: $theme-green-light;
    }

    .selectable--no {
        display: none;
    }
}
</style>
